import { PageTitle } from '@components/PageTitle';

import Form from '../Form';

function CreateNote() {
  return (
    <div>
      <PageTitle hasBackButton title="Nova anotação" />
      <Form />
    </div>
  );
}

export default CreateNote;
